'use strict';

module.exports = function (ngModule) {
    ngModule.directive('sidebarIcon', require('./sidebaricon'));
}


/** WEBPACK FOOTER **
 ** ./src/pages/directives/sidebaricon/index.js
 **/